import { render } from "./slack-preview.vue?vue&type=template&id=801550c8&lang=pug"
import script from "./slack-preview.vue?vue&type=script&lang=js"
export * from "./slack-preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__